import React from 'react';

import { useAllJobProspectsState, useAllJobProspectsActions } from './AllJobProspectsContext';

import StandardModal from '../../Shared/UI/StandardModal/components/StandardModal';
import Form from '../../Shared/UI/Form/components/Form';
import FormInstruction from '../../Shared/UI/FormInstruction/components/FormInstruction';
import FormActions from '../../Shared/UI/FormActions/components/FormActions';
import Button from '../../Shared/UI/Button/components/Button';
import ResponsiveContainer from '../../Shared/UI/ResponsiveContainer/components/ResponsiveContainer';

const ClosedJobModal = () => {
  const state = useAllJobProspectsState();
  const { closeJobClosedWarningModal } = useAllJobProspectsActions();
  
  const jobProspect = state?.jobClosedWarningForm;
  const isOpen = state?.jobClosedWarningModalIsOpen;
  const isJobProspectClosed = jobProspect?.status === 'closed';

  if (!jobProspect) return null;

  const handleVisitJob = () => {
    window.open(jobProspect.link, '_blank', 'noopener,noreferrer');
  };

  return (
    <StandardModal
      isOpen={isOpen}
      contentLabel={isJobProspectClosed ? "Job Prospect Closed" : "Job May Be Closed"}
      onRequestClose={closeJobClosedWarningModal}
    >
      <Form>
        <FormInstruction>
          {isJobProspectClosed ? (
            <>
              <strong>This job prospect is closed.</strong>
              <br />
              <br />
              "{jobProspect.title}" at {jobProspect.biopharmaGroupName} has been marked as closed by {jobProspect.candidateName}.
              <br />
              <br />
              You can still visit the job posting if you want to check if it's been reopened.
            </>
          ) : (
            <>
              <strong>This job may be closed.</strong>
              <br />
              <br />
              We detected that "{jobProspect.title}" at {jobProspect.biopharmaGroupName} might no longer be accepting applications.
              <br />
              <br />
              You can visit the job posting to verify if it's still available.
            </>
          )}
        </FormInstruction>

        <ResponsiveContainer name="form-actions">
          <FormActions>
            <Button
              variant="secondary"
              onClick={handleVisitJob}
            >
              Visit Job Posting
            </Button>
            <Button
              variant="primary"
              onClick={closeJobClosedWarningModal}
            >
              Close
            </Button>
          </FormActions>
        </ResponsiveContainer>
      </Form>
    </StandardModal>
  );
};

export default ClosedJobModal;